import { ApiError } from '@/core/api/http'

export const LOGIN_INVALID = 'E-Mail-Adresse oder Passwort ist nicht korrekt.'
export const LOGIN_FAILED = 'Die Anmeldung ist fehlgeschlagen. Bitte versuchen Sie es erneut.'
export const LOGIN_MISSING = 'Bitte geben Sie E-Mail-Adresse und Passwort ein.'

export const EMAIL_INVALID = 'Bitte geben Sie eine gültige E-Mail-Adresse ein.'
export const REQUEST_FAILED =
  'Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.'

export const REGISTER_SENT =
  'Wenn Ihre E-Mail-Adresse für die Registrierung zugelassen ist, erhalten Sie in Kürze eine E-Mail mit einem Anmeldelink und einem Erstpasswort.'
export const REGISTRATION_LINK_INVALID =
  'Dieser Registrierungslink ist ungültig oder abgelaufen. Melden Sie sich mit dem Erstpasswort aus Ihrer E-Mail an oder registrieren Sie sich erneut.'
export const REGISTERED_NOTICE =
  'Sie sind jetzt registriert. Bitte melden Sie sich mit dem Passwort aus Ihrer E-Mail an.'
export const RESET_REQUESTED =
  'Wenn ein Konto zu dieser E-Mail-Adresse existiert, erhalten Sie in Kürze eine E-Mail mit einem Link zum Zurücksetzen.'

export const RESET_LINK_INVALID =
  'Der Link ist ungültig oder abgelaufen. Bitte fordern Sie einen neuen an.'
export const RESET_DONE = 'Ihr Passwort wurde geändert. Sie können sich jetzt damit anmelden.'

export const PASSWORD_MISSING = 'Bitte geben Sie ein Passwort ein.'
export const PASSWORD_MISMATCH = 'Die Passwörter stimmen nicht überein.'
const PASSWORD_POLICY = 'Das Passwort erfüllt die Anforderungen nicht.'

export const CHANGE_DONE = 'Ihr Passwort wurde geändert.'
export const CHANGE_FAILED =
  'Das Passwort konnte nicht geändert werden. Bitte prüfen Sie Ihre Eingaben.'

export function looksLikeEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())
}

export function passwordPolicyMessage(error: unknown): string | null {
  if (!(error instanceof ApiError) || error.status !== 422) return null
  return error.detailText.trim() || PASSWORD_POLICY
}

function tooManyAttempts(retryAfterSeconds?: number): string {
  if (retryAfterSeconds === undefined) {
    return 'Zu viele Versuche. Bitte versuchen Sie es später erneut.'
  }
  const minutes = Math.max(1, Math.ceil(retryAfterSeconds / 60))
  const unit = minutes === 1 ? 'Minute' : 'Minuten'
  return `Zu viele Versuche. Bitte versuchen Sie es in ${minutes} ${unit} erneut.`
}

export function tooManyAttemptsMessage(error: unknown): string | null {
  if (!(error instanceof ApiError) || error.status !== 429) return null
  return tooManyAttempts(error.retryAfter)
}
